import { useState } from "react";
import { Button, Label, ModalDelete } from "expano-components";
import { Dashboard } from "components";
import useDelete from "hooks/useDelete";

import AddChannel from "./components/AddChannel";

const BrandChannels = ({ brand_id, refetch, data }) => {
  const [is_open_channel_modal, setOpenChannelModal] = useState(false);
  const [brand_channel_to_delete, setBrandChannelToDelete] = useState(null);

  const { is_deleting, _delete } = useDelete({
    path: `/brand_channels/${brand_channel_to_delete?.id}`,
  });

  const handleDelete = async () => {
    await _delete();
    refetch();
    setBrandChannelToDelete(null);
  };
  const existing_channel_ids = data?.map(({ channel }) => channel.id);
  return (
    <Dashboard
      header={{
        icon: "channel",
        title: "Kanały",
      }}
      footer={
        <Button
          type="add"
          text="Przypisz kanał"
          onClick={() => setOpenChannelModal(true)}
        />
      }
    >
      {is_open_channel_modal && (
        <AddChannel
          existing_channel_ids={existing_channel_ids}
          brand_id={brand_id}
          refetch={refetch}
          handleClose={() => setOpenChannelModal(false)}
        />
      )}
      {brand_channel_to_delete?.id && (
        <ModalDelete
          name={`przypisanie marki do kanału ${brand_channel_to_delete?.identifier}?`}
          handleDelete={handleDelete}
          handleClose={() => setBrandChannelToDelete(null)}
        />
      )}
      {data?.length > 0 && (
        <table className="table">
          <tbody className="table__body table-body">
            {data
              .sort((a, b) =>
                a.channel.identifier.localeCompare(b.channel.identifier),
              )
              .map(({ id, channel }) => (
                <tr key={id}>
                  <td>
                    <Label
                      type="double"
                      left={{
                        text: channel?.shop?.label_text,
                        color: `#${channel?.shop?.label_color}`,
                      }}
                      right={{
                        text: channel?.platform?.label_text,
                        color: `#${channel?.platform?.label_color}`,
                      }}
                    />
                    {channel?.identifier}
                  </td>
                  <td>
                    <Button
                      disabled={is_deleting}
                      type="delete-bin"
                      onClick={() =>
                        setBrandChannelToDelete({
                          id,
                          identifier: channel?.identifier,
                        })
                      }
                    />
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      )}
    </Dashboard>
  );
};

export default BrandChannels;
